import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { fetchBistroNwt } from "../../lib/cms.ts";

const DenniNabidkaPage: React.FC = () => {
  const [rablinu, setRablinu] = useState<{ pdf: string | null; text: string }>({
    pdf: null,
    text: "",
  });

  useEffect(() => {
    fetchBistroNwt()
      .then((data) => {
        setRablinu({
          pdf: data?.pdfRablinuUrl || null,
          text: data?.textRablinu || "",
        });
      })
      .catch(console.error);
  }, []);

  const NabidkaKarta = ({
    title,
    color,
    text,
    pdf,
  }: {
    title: string;
    color: string;
    text?: string;
    pdf?: string | null;
  }) => {
    if (!pdf) return null;

    return (
      <section className="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <h2 className="text-xl font-serif font-bold" style={{ color }}>
          {title}
        </h2>

        {text && (
          <p className="text-sm text-[#32180d] leading-relaxed">{text}</p>
        )}

        <div className="w-full aspect-[3/4] bg-gray-100 rounded-xl overflow-hidden pointer-events-none">
          <iframe
            src={pdf + "#toolbar=0&navpanes=0&scrollbar=0"}
            title={title}
            className="w-full h-full"
          />
        </div>

        <a
          href={pdf}
          target="_blank"
          rel="noopener noreferrer"
          className="
            mt-2
            text-center
            bg-[#60260F]
            text-white
            py-3
            rounded-xl
            hover:bg-[#7a3419]
            transition
          "
        >
          Otevřít denní nabídku (PDF)
        </a>
      </section>
    );
  };

  return (
    <>
      <Helmet>
        <title>Denní nabídka | Hospůdka pod Rablinů</title>
      </Helmet>

      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      <main className="bg-[#F5E7CC] min-h-screen text-[#32180d]">
        <section className="bg-white py-16 text-center">
          <h1 className="text-2xl md:text-4xl font-bold font-serif">
            Denní nabídka
          </h1>
        </section>

        <section className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 gap-10">
          <NabidkaKarta
            title="Hospůdka pod Rablinů"
            color="#d97706"
            text={rablinu.text}
            pdf={rablinu.pdf}
          />
        </section>

        <div className="[all:unset] block">
          <Footer />
        </div>
      </main>
    </>
  );
};

export default DenniNabidkaPage;
